import types from './types';
import { ThunkDispatch } from "redux-thunk";
import api from 'constants/api';
import _get from "lodash/get";

export interface GetProviderReportResponse {
  RmiCompanyId: string,
  RmiCreatedBy: string,
  RmiCreatedDate: string,
  RmiFileNamePDF: string,
  RmiFileNameXLS: string,
  RmiModifiedBy: string,
  RmiModifiedDate: string,
  RmiProvId: string,
  RmiProvKeyId: string,
  RmiRevFullName: string,
  RmiRptType: string,
  RmiStoredFilePath: string,
  RmiUid: number
}

export interface DownloadDocument {
  FileName: string,
  FilePath: string
}

export const getProviderReport = (provKey: string, companyId: string, userId: string, rptType: string, measureYear: number, vendorId: string) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_PROVIDER_GAP_REPORT_REQUEST });

  return api.eligibility.gap.getProviderReport(provKey, companyId, userId, rptType, measureYear, vendorId)
    .then((res: any) => {

      dispatch({
        type: types.GET_PROVIDER_GAP_REPORT_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_PROVIDER_GAP_REPORT_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const getProviderHedis = (provKey: string, companyId: string, lob: string, measureYear: number, vendorId: string) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_PROVIDER_HEDIS_GAP_REQUEST });

  if (lob === 'ALL') lob = '';

  return api.eligibility.gap.getProviderHedis(provKey, companyId, lob, measureYear, vendorId)
    .then((res: any) => {

      dispatch({
        type: types.GET_PROVIDER_HEDIS_GAP_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_PROVIDER_HEDIS_GAP_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const getLastRunDate = (provKey: string, companyId: string, reportType: string) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_LAST_RUN_GAP_DATE_REQUEST });

  return api.eligibility.gap.getLastRunDate(provKey, companyId, reportType)
    .then((res: any) => {

      dispatch({
        type: types.GET_LAST_RUN_GAP_DATE_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_LAST_RUN_GAP_DATE_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const getDownloadDocument = (model: DownloadDocument) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {
  if (getState().rootReducer.eligibilityGAP.isDownloadingDoc) { return Promise.reject(); }

  dispatch({ type: types.DOWNLOAD_DOCUMENT_REQUEST });

  return api.eligibility.gap.download(model)
    .then((res: any) => {

      dispatch({
        type: types.DOWNLOAD_DOCUMENT_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.DOWNLOAD_DOCUMENT_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};
